import React from 'react'
import { Link, Redirect } from 'react-router-dom'
import { Layout, Form, Icon, Input, Button, Divider } from 'antd'
import authService from '../services/authentication.service'
import { UserContext } from '../contexts/UserContext'

const { Header } = Layout

class JoinUsLoginForm extends React.Component {
  state = {
    isLoggedIn: false,
  }

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values)
        const authenticated = await authService.authenticateJoinUsUser(
          values.username,
          values.password
        )
        if (authenticated) {
          console.log('authenticated...', authenticated)
          this.context.setJoinUsUser(authService.getAuthenticatedUser())
          this.setState({ isLoggedIn: true })
        }
      }
    })
  }

  render() {
    const { isLoggedIn } = this.state
    const { getFieldDecorator } = this.props.form

    if (isLoggedIn) return <Redirect to="/joinus" />

    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [
              {
                required: true,
                type: 'email',
                message: 'Please input a valid email!',
              },
            ],
          })(
            <Input
              prefix={<Icon type="user" style={{ color: '#FFF' }} />}
              placeholder="Username"
            />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: '#FFF' }} />}
              type="password"
              placeholder="Password"
            />
          )}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            size="large"
            shape="round"
            block={true}
            htmlType="submit"
            className="login-form-button"
          >
            Log in
          </Button>
          <Link to="/joinus/registration">
            <p className="cta-link" style={{ marginBottom: '-15px' }}>
              Don't have an account? Register here
            </p>
          </Link>
          <Link to="/joinus/forgot_password">
            <p className="cta-link">Forgot password? Reset here</p>
          </Link>
        </Form.Item>
      </Form>
    )
  }
}

const WrappedJoinUsLoginForm = Form.create({ name: 'joinus_login' })(
  JoinUsLoginForm
)

const JoinUsLogin = () => {
  return (
    <Layout>
      <section id="login-page">
        <Header className="header">
          <div className="header__logo" />
        </Header>
        <content>
          <section id="login-content">
            <div className="cta">
              <h1>
                Inspire Innovative Approaches for<br></br>Positive Change
              </h1>
              <h3>Survey, Evaluation, Third Party Monitoring</h3>
            </div>
            <Divider type="vertical" />
            <div className="login-form-container">
              <WrappedJoinUsLoginForm />
            </div>
          </section>
        </content>
      </section>
    </Layout>
  )
}

JoinUsLoginForm.contextType = UserContext

export default JoinUsLogin
